import '../../../styles/core.less';

import * as React from 'react'
import { diRegister } from 'stores/diContext'
import {BrowserRouter as Router} from 'react-router-dom';
import { EventService } from '../services/events';
import { SplashpageService } from '../services/splashpage';
import { OrderService } from '../services/order';
import { StripeService } from '../services/stripe';

import { EventStore } from '../stores/events';
import { SplashpageStore } from '../stores/splashpage';
import { CartStore } from "../stores/cart";
import { OrderStore } from "../stores/order";

import { TicketsStore } from "Apps/ticketing/stores/ticket";
import { DonationsStore } from "Apps/ticketing/stores/donation";
import { HttpFactory } from "utils/http";
import { AppStore } from "stores/app";
import { SparxoClientHost } from "Apps/shared/ClientHost";
import Messager from "stores/messager";
import { I18nService } from "stores/i18n";
import i18nConfig from "i18n/ticketing";
import { __urls__ } from "config";

const app = new AppStore();
window["SparxoApp"] = app;
diRegister({
    i18n: new I18nService().init(i18nConfig),
    app ,
    messager: new Messager(),
    api: new HttpFactory(__urls__.api),
    auth: new HttpFactory(__urls__.auth)
});

export class AppContainer extends React.Component<{ app?, basename?}, {}>{
    clientHost: SparxoClientHost;
    
    constructor(props, context) {
        super(props, context);
        const { app } = props;
        diRegister({
            clientHost: new SparxoClientHost(app),
            eventService: new EventService(),
            splashpageService: new SplashpageService(),
            orderService: new OrderService(),
            stripeService: new StripeService(),
            splashpageStore: new SplashpageStore(),
            eventStore: new EventStore(),
            ticketsStore: new TicketsStore(),
            donationsStore: new DonationsStore(),
            cartStore: new CartStore(),
            orderStore: new OrderStore()
        });
    }

    render() {
        return <Router basename={this.props.basename}>
            {this.props.children}
        </Router>
    }

}



// WEBPACK FOOTER //
// ./src/Apps/ticketing/containers/TicketingContainer.tsx